
    <template>
      <div style="margin-top:20px">

        <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
          <span style="font-size: 26px; font-weight: bold">Booking & Actuals Processing Settings</span><br/>
        </div>

        <div v-if="!loading" style="text-align: left; color: #666;" class="d-flex align-items-center justify-content-center">
          <form @submit.prevent="save_config">
            <table width="90%" style="font-size: 18px; font-weight: bold" cellpadding="10px">
              <tr>
                <td align="right" width="500">Enabled</td>
                <td width="800"><b-form-select v-model="model.actuals_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Skip Contract Bookings</td>
                <td width="800"><b-form-select v-model="model.actuals_skip_contract_bookings" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'TBN'">
                <td align="right" width="500">Fall Back To Vehicle Times</td>
                <td width="800"><b-form-select v-model="model.actuals_fall_back_to_vehicle_times" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'TBN'">
                <td align="right" width="500">Fall Back To Vehicle Time (Scheduled Services)</td>
                <td width="800"><b-form-select v-model="model.actuals_fall_back_to_vehicle_times_scheduled_services" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'TBN'">
                <td align="right" width="500">Fall Back To Vehicle Time (Scheduled Services)</td>
                <td width="800"><b-form-select v-model="model.actuals_fall_back_to_vehicle_times_scheduled_services" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'TBN'">
                <td align="right" width="500">Only Populate Live Hours (No Dead, Wait, Driving)</td>
                <td width="800"><b-form-select v-model="model.actuals_only_live_hours" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'TBN'">
                <td align="right" width="500">Flat Hours For Multiday Middle Days</td>
                <td width="800"><b-form-input v-model="model.actuals_multiday_flat_hours" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'CM'">
                <td align="right" width="500">Use Back Arrival Time</td>
                <td width="800"><b-form-select v-model="model.actuals_use_back_arrival_time" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'CM'">
                <td align="right" width="500">Extend Search Range For Multiday</td>
                <td width="800"><b-form-select v-model="model.actuals_extend_search_range_for_multiday" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'CM'">
                <td align="right" width="500">Feed Issues Email Recipient</td>
                <td width="800"><b-form-input v-model="model.actuals_booking_feed_issues_email_recipients" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'CM'">
                <td align="right" width="500">Feed Issues Hours Since Updates To Alert On</td>
                <td width="800"><b-form-input v-model="model.actuals_booking_feed_issues_hours_since" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Date Time Format</td>
                <td width="800"><b-form-input v-model="model.actuals_date_time_format" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'CM'">
                <td align="right" width="500">Allow Partial Actuals</td>
                <td width="800"><b-form-select v-model="model.actuals_allow_partial_actuals" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'CM'">
                <td align="right" width="500">Enable Pickup & Dropoff Actuals</td>
                <td width="800"><b-form-select v-model="model.actuals_allow_pickup_dropoff_actuals" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type === 'CM'">
                <td align="right" width="500">Contract ID Filter</td>
                <td width="800"><b-form-input v-model="model.actuals_contract_id_filter" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Check For Adjacent Bookings</td>
                <td width="800"><b-form-select v-model="model.actuals_check_for_adjacent_bookings" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Check For Overlapping Driver Logs</td>
                <td width="800"><b-form-select v-model="model.actuals_check_for_overlapping_driver_logs" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Check For Overlapping Vehicle Events</td>
                <td width="800"><b-form-select v-model="model.actuals_check_for_overlapping_vehicle_events" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Skip Scheduled Services</td>
                <td width="800"><b-form-select v-model="model.actuals_skip_scheduled_services" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Disable Actuals Mileage</td>
                <td width="800"><b-form-select v-model="model.actuals_mileage_disabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Email Recipients</td>
                <td width="800"><b-form-input v-model="model.actuals_email_recipients" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Finish Time Offset Config</td>
                <td width="800"><b-form-input v-model="model.actuals_finish_time_offset_config" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type == 'TBN'">
                <td align="right" width="500">Send Actuals To TBN Enabled</td>
                <td width="800"><b-form-select v-model="model.actuals_outbound_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type == 'TBN'">
                <td align="right" width="500">Outbound Booking Disabled</td>
                <td width="800"><b-form-select v-model="model.actuals_outbound_bookings_disabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type == 'TBN'">
                <td align="right" width="500">Outbound Scheduled Services Disabled</td>
                <td width="800"><b-form-select v-model="model.actuals_outbound_scheduled_services_disabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Use Telematics Geofences</td>
                <td width="800"><b-form-select v-model="model.actuals_use_eld_geofences" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Supports Live & Dead Mileage</td>
                <td width="800"><b-form-select v-model="model.actuals_supports_live_dead_mileage" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Filter Bookings By Company</td>
                <td width="800"><b-form-select v-model="model.actuals_filter_bookings_view_by_company" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Driver HOS Required</td>
                <td width="800"><b-form-select v-model="model.actuals_driver_hos_required_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Pull DVIR Data</td>
                <td width="800"><b-form-select v-model="model.actuals_use_dvirs_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Supports Booking By Vehicle Company</td>
                <td width="800"><b-form-select v-model="model.actuals_supports_booking_by_vehicle_company" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type == 'TBN'">
                <td align="right" width="500">Ignore Missing Segment Locations</td>
                <td width="800"><b-form-select v-model="model.actuals_ignore_missing_segment_locations" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type == 'CM'">
                <td align="right" width="500" >Ignore Booking If Missing Vehicle</td>
                <td width="800"><b-form-select v-model="model.actuals_ignore_booking_if_vehicle_is_missing" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type == 'CM'">
                <td align="right" width="500">Ignore Missing Mileage</td>
                <td width="800"><b-form-select v-model="model.actuals_ignore_missing_mileage" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type == 'TBN'">
                <td align="right" width="500">Actuals Base Config</td>
                <td width="800"><b-form-textarea v-model="model.actuals_base_config" style="field-sizing: content"/></td>
                <td width="250">only process actuals for these bases</td>
              </tr>
              <tr v-if="tenant_type == 'TBN'">
                <td align="right" width="500">Outbound Base Config</td>
                <td width="800"><b-form-textarea v-model="model.actuals_outbound_base_config" style="field-sizing: content"/></td>
                <td width="250">only send actuals to TBN for these bases</td>
              </tr>
              <tr v-if="tenant_type == 'TBN'">
                <td align="right" width="500">Outbound Auto Verify Config</td>
                <td width="800"><b-form-textarea v-model="model.actuals_outbound_auto_verify_config" style="field-sizing: content"/></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Default Geofence Meters</td>
                <td width="800"><b-form-input v-model="model.actuals_default_geofence_meters" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">HOS Active Statuses</td>
                <td width="800"><b-form-input v-model="model.actuals_hos_active_statuses" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Support Booking Bases</td>
                <td width="800"><b-form-input v-model="model.actuals_supported_booking_bases" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type=='CM'">
                <td align="right" width="500">Supports Client IDs</td>
                <td width="800"><b-form-input v-model="model.actuals_supported_client_ids" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Excluded Booking Bases</td>
                <td width="800"><b-form-input v-model="model.actuals_excluded_booking_bases" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type=='CM'">
                <td align="right" width="500">Exclude Non Diary Bookings</td>
                <td width="800"><b-form-select v-model="model.actuals_exclude_non_diary_bookings" :options="boolean_options" style="width:100px"></b-form-select></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Excluded Booking Types</td>
                <td width="800"><b-form-input v-model="model.actuals_excluded_booking_types" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr>
                <td align="right" width="500">Excluded Booking Vehicles</td>
                <td width="800"><b-form-input v-model="model.actuals_excluded_booking_vehicles" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type=='TBN'">
                <td align="right" width="500">Minutes After Finish Time To Process Actuals</td>
                <td width="800"><b-form-input v-model="model.actuals_processing_delay_in_minutes" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="tenant_type=='CM'">
                <td align="right" width="500">Client ID Filter</td>
                <td width="800"><b-form-input v-model="model.actuals_client_id_filter" type="text"></b-form-input></td>
                <td width="250">&nbsp;</td>
              </tr>
              <tr v-if="is_admin">
                <td align="right"><span style="color: steelblue; font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isAdvVisible')">+ Advanced</span></td>
                <td></td>
                <td></td>
              </tr>
              <template v-if="toggle.isAdvVisible">
                <tr>
                  <td align="right" width="500">Skip Duplicate Bookings Updates</td>
                  <td width="800"><b-form-select v-model="model.actuals_skip_duplicate_booking_updates" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr>
                  <td align="right" width="500">Prime Locations & HOS</td>
                  <td width="800"><b-form-select v-model="model.actuals_prime_locations_and_hos" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Refresh Bookings Disabled</td>
                  <td width="800"><b-form-select v-model="model.actuals_refresh_bookings_disabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Refresh Bookings Nightly Disabled</td>
                  <td width="800"><b-form-select v-model="model.actuals_refresh_bookings_nightly_disabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Sync Drivers Disabled</td>
                  <td width="800"><b-form-select v-model="model.tbn_sync_drivers_skip" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Sync Vehicles Disabled</td>
                  <td width="800"><b-form-select v-model="model.tbn_sync_vehicles_skip" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Days In The Future</td>
                  <td width="800"><b-form-input v-model="model.actuals_refresh_booking_days_in_future" type="text"></b-form-input></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Refresh Minutes Past The Hour</td>
                  <td width="800"><b-form-input v-model="model.actuals_refresh_bookings_minutes_past_the_hour" type="text"></b-form-input></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Force Outbound Enabled</td>
                  <td width="800"><b-form-select v-model="model.actuals_force_outbound_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Force Booking Updates Enabled</td>
                  <td width="800"><b-form-select v-model="model.actuals_force_booking_updates_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='TBN'">
                  <td align="right" width="500">Save Booking History Enabled</td>
                  <td width="800"><b-form-select v-model="model.actuals_save_booking_history_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
                  <td width="250">&nbsp;</td>
                </tr>
                <tr v-if="tenant_type=='CM'">
                  <td align="right" width="500">Max Days Ago To Process Bookings</td>
                  <td width="800"><b-form-input v-model="model.actuals_max_days_ago" type="text"></b-form-input></td>
                  <td width="250">&nbsp;</td>
                </tr>

              </template>
            </table>

            <hr/>
            <div style="position: relative" class="d-flex align-items-center justify-content-center">
              <b-btn size="lg" type="submit" variant="success" id="save-user-submit">Save</b-btn>
              &nbsp;&nbsp;<b-btn size="lg" @click="load_data()">Cancel</b-btn>
            </div>

          </form>
        </div>
        <div v-else>
          <br/><br/>
          <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
        </div>
      </div>

    </template>
    <script>
      import {get_tenant_config_settings, update_tenant_config_settings} from '../networking/apis'
      import {mapState} from "vuex";

      export default {
        name: 'tenant_config',
        components: {
        },

        data() {
          return {
            group_name: 'general',
            add_yard_model: {},
            manage_sos_yards: false,
            model: {},
            general_model: {},
            general_advanced_model: {},
            toggle: {},
            summary: {},
            loading: true,
            isNotSysadmin: false,
            isSamaraType: false,
            yardsLength: 0,
            objectKeyList: [],
            boolean_options: [
              { text: 'True', value: 'True' },
              { text: 'False', value: 'False' },
            ],
          }
        },
        async mounted() {
          this.load_data()
        },
        methods: {
          async load_data() {
            this.loading = true
            try {
              const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
              this.summary = data.summary
              this.model = data.results

              try {
                const entries = Object.entries(this.model);
                for (let [key, value] of entries) {
                  if (this.isArrayType(value) || this.isPlainObject(value, key)) {
                    let setting = JSON.stringify(value)
                    //console.log('found plain object or array: key:' + key + ' value: ' + setting);
                    this.model[key] = setting
                    this.objectKeyList.push(key)
                  }
                }
              } catch (e) {
                console.log('error looping through keys', e)
              }

            } catch(e) {
              this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
            }

            this.loading = false
          },
          async save_config() {
            try {
              window.scrollTo(0,0);

              //return value to object 
              try {
                //console.log("this.objectKeyList: " + JSON.stringify(this.objectKeyList))
                for (const objkey of this.objectKeyList) {
                  let setting = JSON.parse(this.model[objkey])
                  this.model[objkey] = setting
                }
              } catch (e) {
                console.log('exception parsing object keys', e)
              }

              this.$emit('showAlert', 'Saving Changes', 'info',5000)
              await update_tenant_config_settings(this.user.tenant, this.model, this.group_name)
              this.load_data()
              this.$emit('showAlert', 'Configuration Saved', 'success',5000)
            } catch(e) {
              this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
            }
          },
          set_tenant_id(id) {
            this.user.tenant = id
            this.load_data()
          },
          update_toggle_div(item,field,setting) {
            if (!item[field] && setting) {
              item[field] = !item[field];
              this.$forceUpdate();
            } else if (item[field] && !setting) {
              item[field] = !item[field];
              this.$forceUpdate();
            }
          },
          toggle_div(item,field) {
            item[field] = !item[field];
            this.$forceUpdate();
          },
          isPlainObject(value, key) {
            //console.log('isPlainObject, value:' + value + ', type of value:' + (typeof value))
            let objtype = (typeof value)
            if (objtype == "object") {
              if (value != null && !Array.isArray(value)) {
                return true
              }
              return false
            }
          },
          isArrayType(value) {
            return Array.isArray(value)
          },
        } ,
        computed:{
          ...mapState({
            user: state => state.profile.user
          }),
          is_admin() {
            return this.user.role === 'admin'
          },
          telematics_type() {
            return this.user.telematics_types[this.user.tenant]
          },
          tenant_type() {
            return this.user.types[this.user.tenant]
          }
        },
        watch: {
          user: {
            deep: true,
            handler() {
              this.load_data()
            }
          }
        }
      }
    </script>
    <style>
      @import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
      @import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
      @import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
      @import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
      @import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
      @import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
      @import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
      @import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";
    </style>

